import { Table } from "react-bootstrap";
import $ from "jquery";

export default function Certificates(props) {
  const certificates = [
    {
      name: "CSS FROM HACKERRANK",
      year: "AUG 2021",
      url: "https://www.hackerrank.com/certificates/5aa5072c11dc",
    },
    {
      name: "AWS FUNDAMENTALS",
      year: "DEC 2020",
      url: "https://www.coursera.org/account/accomplishments/certificate/GEM6PFDCW7FB",
    },
    {
      name: "PROBLEM SOLVING FROM HACKERRANK",
      year: "FEB 2021",
      url: "https://www.hackerrank.com/certificates/4fd35dbc416d",
    },
    {
      name: "HTML & CSS",
      year: "SEPT 2020",
      url: "https://www.coursera.org/account/accomplishments/certificate/9JD9LN4QNDQF",
    },
    {
      name: "AI FOR EVERYONE FROM DEEPLEARNING.AI",
      year: "JUL 2020",
      url: "https://www.coursera.org/account/accomplishments/certificate/GSDZP3ESH5UB",
    },
  ];

  $(document).ready(function () {
    $("table a").hover(
      function () {
        $(this).parent().parent().animate(
          {
            backgroundColor: "#da2c38",
          },
          1000
        );
      },
      function () {
        $(this).parent().parent().animate(
          {
            backgroundColor: "transparent",
          },
          1000
        );
      }
    );
  });

  return (
    <>
      <Table className="mt-5">
        <tbody className="text-light">
          {certificates.map((item, key) => (
            <tr key={key}>
              <td>
                <a className="text-light" href={item.url}>
                  {item.name}
                </a>
              </td>
              <td>{item.year}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
}
